
export enum DynamicPriceEventTypeCd {
	CREATE_DYN_PRICE_RULE = 'CreateDynPriceRule',
	RATE_REQUEST_RESPONSE = 'RateRequestResponse',
	UPDATE_DYN_PRICE_RULE = 'UpdateDynPriceRule'}

